import CandidateUploadedDocuments from './CandidateUploadedDocuments.component';

export default CandidateUploadedDocuments;